module.exports = __webpack_public_path__ + "static/media/ic_product_st_design.1c8701fa.svg";